import { Info } from 'lucide-react';
import { admin, palette, radii, typography } from '../../../../styles/tokens';

interface CapabilityTransparencyHintProps {
  rowsWithoutContact: number;
}

// Capability-transparency over gatekeeping (Golden Rule #7). Rows without
// phone/email are still valid — this hint tells the user what they lose,
// not what they can't do.
export default function CapabilityTransparencyHint({
  rowsWithoutContact,
}: CapabilityTransparencyHintProps) {
  if (rowsWithoutContact <= 0) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        padding: 14,
        background: palette.g50,
        border: `1px solid ${palette.g150}`,
        borderRadius: radii.sm,
        fontSize: typography.size.caption,
        color: admin.body,
        lineHeight: typography.lineHeight.relaxed,
      }}
    >
      <Info size={16} color={palette.g500} style={{ flexShrink: 0, marginTop: 1 }} />
      <span>
        {rowsWithoutContact} clients have no phone or email — they&rsquo;ll
        import fine, but these clients won&rsquo;t receive appointment
        reminders, birthday messages, or marketing campaigns until you add a
        way to reach them. You can add contact info anytime from the Clients
        page.
      </span>
    </div>
  );
}
